import { FilterValueListService, FilterValue } from '../filter/types';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OfferAccrualCode } from '@app/core/types/client-pricing-offer';
import { AccrualTypeTranslationPipe } from '../credit/pipes/accrual-component-type-to-translation-key.pipe';
import { AccrualCode } from '@app/core/types/accrual';

@Injectable()
export class OfferAccrualTypeValueListService implements FilterValueListService {
  constructor(private translateService: TranslateService) {}

  getFilterValues$(): FilterValue[] {
    const accrualTypeTranslationPipe: AccrualTypeTranslationPipe = new AccrualTypeTranslationPipe();

    // For type conversion since using casting "as" didnt work
    const accrualCodeMapping: Record<OfferAccrualCode, AccrualCode> = {
      // [OfferAccrualCode.INTEREST]: AccrualCode.INTEREST,
      [OfferAccrualCode.FORFEIT]: AccrualCode.FORFEIT,
      [OfferAccrualCode.UTILIZATION_FEE]: AccrualCode.UTILIZATION_FEE,
      [OfferAccrualCode.EARLY_REPAYMENT_FEE]: AccrualCode.EARLY_REPAYMENT_FEE,
    };
    
    return Object.values(OfferAccrualCode).map((offerAccrualCode: OfferAccrualCode): FilterValue => {
      const mappedAccrualCode = accrualCodeMapping[offerAccrualCode];
      
      return {
        value: offerAccrualCode,
        displayText: this.translateService.instant(
          accrualTypeTranslationPipe.transform(mappedAccrualCode)
        ),
      };
    });
  }
}

// @Injectable()
// export class OfferAccrualTypeValueListService implements FilterValueListService {
//   constructor(
//     private translateService: TranslateService,
//     private clientPricingOfferService: ClientPricingOfferService
//   ) { }

//   getFilterValues$(): Observable<FilterValue[]> {
//     const accrualTypeTranslationPipe: AccrualTypeTranslationPipe = new AccrualTypeTranslationPipe();

//     return this.clientPricingOfferService.getClientPricingAccrualTypes$().pipe(
//       map((offerAccrualTypes: AccrualCode[]) => {
//         return offerAccrualTypes.map((accrualCode: AccrualCode): FilterValue => {
//           return {
//             value: accrualCode,
//             displayText: this.translateService.instant(
//               accrualTypeTranslationPipe.transform(accrualCode)
//             ),
//           };
//         });
//       })
//     );
//   }
// }